import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MUIButton from '@material-ui/core/Button';
import cn from 'classnames';
import * as React from 'react';
import { testAttr } from '../../helpers';
import Icon from '../Icon';
import withStyles from '../withStyles';
import styles from './Button.styles';
export const Button = ({ className, label, icon, iconAlignment = 'end', color = 'default', size = 'default', hideBorder = false, disabled = false, type = 'button', fullWidth = false, children, onClick, classes, testId, }, ref) => {
    const hasIcon = !!icon;
    const hasLabel = !!label || !!children;
    const iconEl = hasIcon && (_jsx("div", Object.assign({ className: cn(classes.icon, hasLabel && classes.iconWithLabel, fullWidth && classes.iconWithLabelFullWidth) }, { children: typeof icon === 'string' ? _jsx(Icon, { icon: icon }) : icon })));
    let contents = [label || children, iconEl];
    if (iconAlignment === 'start') {
        contents = contents.reverse();
    }
    return (_jsxs(MUIButton, Object.assign({ ref: ref, variant: "contained", disabled: disabled, type: type, fullWidth: fullWidth, onClick: onClick, classes: {
            root: cn(classes.button, hasIcon && !hasLabel && classes.buttonOnlyIcon, hasIcon && hasLabel && classes.buttonWithIconAndLabel, iconAlignment === 'start'
                ? classes.iconAlignStart
                : classes.iconAlignEnd, fullWidth && classes.buttonFullWidth, hideBorder && classes.hideBorder, color === 'default' && classes.default, color === 'primary' && classes.primary, color === 'destructive' && classes.destructive, color === 'progress' && classes.progress, color === 'light' && classes.light, size === 'small' && classes.small, className),
            label: classes.label,
        } }, testAttr(testId), { children: [contents[0], contents[1]] })));
};
// @ts-ignore
export default withStyles(styles)(React.forwardRef(Button));
//# sourceMappingURL=Button.js.map